import { useState } from 'react'

import { Directions } from '@/lib/constants'

const useWithinPageNav = ({
  numOfFormElements,
}: {
  numOfFormElements: number
}) => {
  const [activeElementIndex, setActiveElementIndex] = useState(0)

  const handleChangeActiveElemIndex = (index: number) => {
    if (index === activeElementIndex) return
    setActiveElementIndex(index)
  }

  const handleWithinPageNav = (d: Directions) => {
    if (d === Directions.NEXT && activeElementIndex < numOfFormElements - 1) {
      return setActiveElementIndex((prevIndex) => prevIndex + 1)
    }
    if (d === Directions.PREV && activeElementIndex > 0) {
      return setActiveElementIndex((prevIndex) => prevIndex - 1)
    } else return
  }

  return {
    activeElementIndex,
    handleWithinPageNav,
    handleChangeActiveElemIndex,
  }
}

export default useWithinPageNav
